import api from '../connectors/Api'

const API = api()

export default {
  namespaced: true,
  state: {
    members: {},
    candidates: {}
  },

  mutations: {
    setMembers (state, { list, campaignId }) {
      const members = { ...state.members }
      members[campaignId] = list
      state.members = members
    },
    setCandidates (state, { list, campaignId }) {
      const candidates = { ...state.candidates }
      candidates[campaignId] = list
      state.candidates = candidates
    }
  },
  getters: {

  },
  actions: {
    getMembers ({ commit, state, dispatch }, campaignId) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true })
          .then((token) => {
            API.getCampaignMembersAdvertiser(token, campaignId)
              .then((res) => {
                commit('setMembers', { list: res.body.list, campaignId })
                resolve(res.body.list)
              })
              .catch((e) => {
                reject(e)
              })
          }).catch((e) => {
            reject(e)
          })
      })
    },
    inviteMember ({ commit, state, dispatch }, { campaignId, influencerId }) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true })
          .then((token) => {
            const data = {
              campaign_id: campaignId,
              influencer_id: influencerId
            }
            API.inviteCampaignMember(token, data)
              .then((res) => {
                dispatch('getMembers', campaignId)
                resolve(res.body)
              })
              .catch((e) => {
                reject(e)
              })
          }).catch((e) => {
            reject(e)
          })
      })
    },
    cancelInvite ({ commit, state, dispatch }, { campaignId, memberId }) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true })
          .then((token) => {
            API.cancelInvitedCampaignMember(token, memberId)
              .then((res) => {
                dispatch('getMembers', campaignId)
                resolve(res.body)
              })
              .catch((e) => {
                reject(e)
              })
          }).catch((e) => {
            reject(e)
          })
      })
    },
    getCandidates ({ commit, state, dispatch }, campaignId) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true })
          .then((token) => {
            API.getCampaignCandidates(token, campaignId)
              .then((res) => {
                commit('setCandidates', { list: res.body, campaignId })
                resolve(res.body)
              })
              .catch((e) => {
                reject(e)
              })
          }).catch((e) => {
            reject(e)
          })
      })
    }
  }
}
